<template>
<div>
  <div id="vinlocity-registration-page" class="container" style="margin-bottom: 50px">
    <div id="body">
      <div class="row">

        <div class="col-xs-12 col-md-5 col-md-offset-2">
          <p style="font-size: 24px">
            <strong>Create your account to get started</strong>
          </p>
        </div>

        <div class="col-xs-12 col-md-3">
          <p style="margin-top: 12px">
            Already have an account?
            <a style="color: #ed7800; font-weight: bold" href="/client/login">Login</a>
          </p>
        </div>

        <div class="col-xs-12 col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-md-2"></div>

        <div class="col-xs-12 col-md-8">
          <p>Complete each section to continue registration</p>
        </div>

        <div class="col-xs-12 col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-md-2"></div>

        <div class="col-xs-12 col-md-8">
          <form class="form" id="registration_form" name="registration_form">

            <div class="form-group col-xs-12 col-md-6 first_name_container container">
              <label class="control-label control-label-required" for="fname">First Name</label>
              <input type="text" id="fname" name="fname" class="form-control" v-model="first_name" placeholder="First Name"/>
              <p id="first_name_help_block" class="help-block help-block-text"></p>
            </div>

            <div class="form-group col-xs-12 col-md-6 last_name_container container">
              <label class="control-label control-label-required" for="lname">Last Name</label>
              <input type="text" id="lname" name="lname" class="form-control" v-model="last_name" placeholder="Last Name"/>
              <p id="last_name_help_block" class="help-block help-block-text"></p>
            </div>

            <div class="form-group col-xs-12 email_container container">
              <label class="control-label control-label-required" for="email">Email</label>
              <input type="email" id="email" name="email" class="form-control" v-model="email" placeholder="Your Email Address" autocomplete="email username"/>
              <p id="email_help_block" class="help-block help-block-text"></p>
            </div>

            <div class="form-group col-xs-12 password_container container">
              <label class="control-label control-label-required" for="password">Password</label>
              <input type="password" id="password" name="password" class="form-control" v-model="password" placeholder="Password" autocomplete="new-password"/>
            </div>

            <div class="form-group col-xs-12 password_container container">
              <label class="control-label control-label-required" for="password_confirmation">Password Confirmation</label>
              <input type="password" id="password_confirmation" name="password_confirmation" class="form-control" v-model="password_confirmation" placeholder="Password Confirmation" autocomplete="new-password"/>
              <p id="password_confirmation_help_block" class="help-block help-block-text"></p>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <br />
                <br />
              </div>
            </div>

            <p style="font-size: 18px"><strong>Company Information</strong></p>
            <p>
              Your registration is almost complete, please tell us more about
              your company
            </p>

            <div class="form-group col-xs-12 company_name_container container">
              <label class="control-label control-label-required" for="company_name">Company Name</label>
              <input type="text" id="company_name" name="company_name" class="form-control" v-model="company_name" placeholder="Company Name"/>
              <div id="company_name_help_block" class="help-block help-block-text"></div>
            </div>

            <div class="address-auto-complete-container address1_container">
              <address-auto-complete placeholder="Business Address" id="address1" :address.sync="address"/>
              <div id="address1_help_block" class="help-block help-block-text"></div>
            </div>

            <div class="form-group col-xs-12 phone_number_container container">
              <label class="control-label control-label-required" for="phone_number">Phone Number</label>
              <phone-validation v-model="phone_number" aria-describedby="basic-addon1"></phone-validation>
              <p id="phone_number_help_block" class="help-block help-block-text"></p>
            </div>

            <div class="form-group col-xs-12 company_website_container container">
              <label class="control-label" for="company_website">Company Website</label>
              <input type="text" id="company_website" name="company_website" class="form-control" v-model="company_website" placeholder="Company Website"/>
              <p id="company_website_help_block" class="help-block help-block-text"></p>
            </div>

            <div class="form-group col-xs-12 container">
              <input type="checkbox" disabled id="tos" name="tos" v-model="tos"/>
              <label class="control-label" for="tos">I have read and agree to the
                <a data-toggle="modal" data-target="#terms-and-conditions-modal" class="terms-of-agreement-link" target="_blank">Terms and Conditions</a></label>
            </div>

            <div class="vinlocity-tos" id="vinlocity-tos">
              <terms-and-conditions-modal :auth="false" />
            </div>

            <div class="row">
              <div class="col-xs-12">
                <button type="button" class="btn btn-primary btn-rounded btn-padding btn-register-margin-bottom" id="register" name="register" disabled v-on:click="submit()">
                  Create Account
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-xs-12 col-md-2"></div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="loading-modal" tabindex="-1" role="dialog" aria-labelledby="modal-label" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="vertical-alignment-helper">
          <div class="modal-dialog vertical-align-center">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4 class="modal-title" id="modal-label">Please wait. Don't click out of this window.</h4>
                  </div>

                  <div class="modal-body">
                      <div id="progress-bar-container" class="progress">
                          <div id="progress-bar" class="progress-bar progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">

                          </div>
                      </div>
                      <div id="progress-bar-status" class="progress-bar-status blink text-center">Validating Registration Form....</div>
                      <div id="modal-footer-button"></div>
                  </div>

                  <div class="modal-footer">
                      <p id="modal-footer-text" class="text-center">Thank you for registering. Please wait a moment while your customized website is being built!</p>
                    <button type="button" class="btn btn-primary btn-rounded hidden" data-dismiss="modal" id="close-modal">Close</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      address: {
        address_1: "",
        city: "",
        state: "",
        zipcode: "",
      },
      email: "",
      first_name: "",
      last_name: "",
      password: "",
      password_confirmation: "",
      company_name: "",
      phone_number: "",
      company_website: "",
      tos: false,
      session_id: window.Echo.connector.pusher.sessionID,
      registration_id: null,
      database_name: ""
    };
  },
  methods: {
    submit: function () {
      $(".help-block").text("");
      $(".has-error").removeClass("has-error");

      axios
        .post("/VINlocity/registration", {
          sessionId: this.session_id,
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          password: this.password,
          password_confirmation: this.password_confirmation,
          company_name: this.company_name,
          address1: this.address.address_1,
          city: this.address.city,
          state: this.address.state,
          zipcode: this.address.zipcode,
          phone_number: this.phone_number,
          company_website: this.company_website,
          tos: this.tos,
        })
        .then(function (response) {
          this.registration_id = response.data.registration_id;
          this.database_name = response.data.database_name;
          this.createDb(response);
        }.bind(this))
        .catch(function (error) {

          let errors = error.response.data.errors;
          $.each(errors, function (index, value) {
            $("." + index + "_container").addClass("has-error");
            $("#" + index + "_help_block").text(value[0]);

            if (index === "tos") {
              $("#terms-agreement-text").text(
                "You must accept the terms and conditions to register."
              );

              $("#terms-of-agreement-modal").modal("toggle");
            }
            if (index === "password") {
              $("#password_confirmation_help_block").text(value[0]);
            }
            $("#loading-modal").modal("hide");
          });
        });
    },
    createDb: function (response) {
      axios.post("/VINlocity/register-database", {
        sessionId: this.session_id,
        database_name: this.database_name
      }).then(function (response) {
        this.register(response);
      }.bind(this))
    },
    register: function (response) {
      axios.post("/VINlocity/register", {
        sessionId: this.session_id,
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        password: this.password,
        password_confirmation: this.password_confirmation,
        company_name: this.company_name,
        address1: this.address.address_1,
        city: this.address.city,
        state: this.address.state,
        zipcode: this.address.zipcode,
        phone_number: this.phone_number,
        company_website: this.company_website,
        registration_id: this.registration_id,
        database_name: this.database_name
      }).then(function (response) {
        window.location.replace("http://" + response.data.domain);
      });
    }
  },
  created() {
    var pusher = window.Echo.connector.pusher;
    var tenantRegisteredChannel = pusher.subscribe("tenant-registered-" + this.session_id);
    var databaseCreatedChannel = pusher.subscribe("database-created-" + this.session_id);
    var databasePopulatedChannel = pusher.subscribe("database-populated-" + this.session_id);
    var registrationCompleteChannel = pusher.subscribe("registration-complete-" + this.session_id);
    var registrationFailedChannel = pusher.subscribe('tenant-failed-to-register-' + this.session_id);

    tenantRegisteredChannel.bind("App\\Events\\TenantRegistration\\TenantRegistered", function (data) {
        $("#loading-modal").modal("toggle");

        $(".progress-bar").css("width", data.status).text(data.status);
        $(".progress-bar-status").text(data.nextStep);
      }
    );

    databaseCreatedChannel.bind("App\\Events\\TenantRegistration\\DatabaseCreated", function (data) {
        $(".progress-bar").css("width", data.status).text(data.status);
        $(".progress-bar-status").text(data.nextStep);
      }
    );

    databasePopulatedChannel.bind("App\\Events\\TenantRegistration\\DatabasePopulated", function (data) {
        $(".progress-bar").css("width", data.status).text(data.status);
        $(".progress-bar-status").text(data.nextStep);
      }
    );

    registrationCompleteChannel.bind("App\\Events\\TenantRegistration\\RegistrationComplete", function (data) {
        $(".progress-bar").css("width", data.status).text(data.status);
        $(".progress-bar-status ").text("").hide();

        $("#loading-modal").modal("hide");
      }
    );

    registrationFailedChannel.bind('App\\Events\\TenantRegistration\\TenantFailedToRegister', function(data) {
      $('.progress-bar').css('width', data.status).text(data.status);
      $(".progress-bar-status").text(data.nextStep);
      $('#modal-footer-text').text("");
      $('#modal-label').text("Account creation error");
      $('#close-modal').removeClass("hidden");
    });


  }
};
</script>